import { render, staticRenderFns } from "./wallet-empty.vue?vue&type=template&id=84ce1fae&"
import script from "./wallet-empty.vue?vue&type=script&lang=js&"
export * from "./wallet-empty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('84ce1fae')) {
      api.createRecord('84ce1fae', component.options)
    } else {
      api.reload('84ce1fae', component.options)
    }
    module.hot.accept("./wallet-empty.vue?vue&type=template&id=84ce1fae&", function () {
      api.rerender('84ce1fae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/svg/wallet-empty.vue"
export default component.exports